/**
* API'den gelen analitik verisini işler
* @param {Object} responseData - API yanıtı
* @returns {Object} - İşlenmiş veri
*/
export function processAnalyticsData(responseData) {
 // API yanıtı yoksa boş nesne döndür
 if (!responseData) {
   return {
     byCountry: {},
     byDate: {},
     byDevice: {},
     bySource: {},
     rawData: [],
     totals: {
       sessions: 0,
       activeUsers: 0,
       bounceRate: 0,
       conversions: 0,
       totalRevenue: 0,
     },
   };
 }

 // Veri iki seviye iç içe geçmiş olabilir
 const analyticsData = responseData.data || responseData;

 return {
   byCountry: analyticsData.byCountry || {},
   byDate: analyticsData.byDate || {},
   byDevice: analyticsData.byDevice || {},
   bySource: analyticsData.bySource || {},
   rawData: analyticsData.rawData || [],
   totals: analyticsData.totals || {
     sessions: 0,
     activeUsers: 0,
     bounceRate: 0,
     conversions: 0,
     totalRevenue: 0,
   },
 };
}